import ApiClient, {requestRemoteData} from '../../API/api';
import {toLocalDateString} from '../../common/utils/date.utils';

const GET_FILTERED_SHIPMENTS = 'shipments/all/filter';
const GET_PDF_SHIPMENT = 'shipments/download';
const GET_BULK_PDF_SHIPMENTS = 'shipments/bulk/download';

const actingAsHeaders = (actingAsNumCliente) =>
  actingAsNumCliente ? { 'X-Acting-As-Client': actingAsNumCliente } : {};

/**
 * Albaranes registrados en BC del cliente (o del suplantado en modo comercial),
 * por fecha de registro del albaran.
 * @param {DateRange} dateRange
 * @param {string|null} actingAsNumCliente
 * @returns {Promise<RemoteData<Shipment[]>>}
 */
export const fetchShipmentsInDateRange = (dateRange, actingAsNumCliente = null) => {
  return requestRemoteData(
    GET_FILTERED_SHIPMENTS,
    {
      headers: actingAsHeaders(actingAsNumCliente),
      queryParams: {
        fromDate: toLocalDateString(dateRange.from),
        toDate: toLocalDateString(dateRange.to)
      }
    });
};

/**
 * @param {string} number - numero de albaran de BC (AV26/053768)
 * @param {string|null} actingAsNumCliente
 * @return Promise<Blob>
 */
export const fetchPdfShipment = (number, actingAsNumCliente = null) => {
  return ApiClient.performRequest(
    GET_PDF_SHIPMENT,
    {
      queryParams: { number },
      headers: { ...actingAsHeaders(actingAsNumCliente), 'accept': 'application/pdf', 'Content-Type': 'application/pdf' }
    });
};

/**
 * @param {string[]} numbers
 * @param {string|null} actingAsNumCliente
 * @return Promise<RemoteData<Blob>>
 */
export const fetchBulkPdfShipments = (numbers, actingAsNumCliente = null) => {
  return requestRemoteData(
    GET_BULK_PDF_SHIPMENTS,
    {
      method: 'POST',
      headers: { ...actingAsHeaders(actingAsNumCliente), 'accept': 'application/octet-stream' },
      body: numbers
    });
};
